export default __webpack_public_path__ + "static/media/ic-receive-coin.294ea76d.svg";